import { once } from 'lodash-es';
import { environment as env } from 'src/environments/environment';
import { isEnvironment } from '../models/environment.type-guard';

export const environmentFactory = once((document: Document) => {
    let environment: string;
    if (!env.production) {
        environment = 'local';
    } else {
        environment = document.querySelector('html')?.dataset.env || '';
    }
    if (!environment) {
        console.error('html[data.env] missing, defaulting to dev');
        environment = 'dev';
    }

    environment = environment.toLowerCase();
    if (environment === 'qa') {
        const qaEnvironment = document.querySelector('html')?.dataset.qaEnv;
        if (qaEnvironment === 'stage') {
            environment = 'stage';
        } else if (qaEnvironment === 'dev') {
            environment = 'dev';
        } else {
            environment = 'test';
        }
    } else if (environment === 'production') {
        environment = 'prod';
    }

    if (!isEnvironment(environment)) {
        console.error('html[data.env] unexpected value, defaulting to dev');
        return 'dev';
    } else {
        return environment;
    }
});
